import React, { useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import './AdmitPatientEvent.scss'
import moment from 'moment'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import MobiScrollCalendar from '../../../../../../components/common/MobiScrollCalendar/MobiScrollCalendar'
import { overwritePatientEvent, processPatientEventDate } from './sharedPatientEventFunctions'

const today = format(new Date(), 'yyyy-MM-dd')

function getLaterDate(date) {
  return date > today ? date : today
}

// the special admit date that Medrina wants
export default function DischargePatientEventModal({
  visit,
  onClose,
  onChange,
  date,
  isPatientEventCard = false,
  min,
}) {
  const [newDate, setNewDate] = useState(date)

  // prevent spam clicks
  const [isClicked, setIsClicked] = useState(false)

  const dischargePatientEventDate = visit?.dischargePatientEvent?.date

  return (
    <CModal
      className="confirm-modal"
      visible={true}
      onClose={onClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">Edit Discharge Date</CModalHeader>
      <CModalBody>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div className="admit-date-selector">
            <div className="label">Discharge Date</div>
            <div className="admit-date-input">
              <MobiScrollCalendar
                placeholder="MM / DD / YYYY"
                value={
                  newDate || dischargePatientEventDate
                    ? moment.utc(newDate || dischargePatientEventDate).format('MM/DD/YYYY')
                    : ''
                }
                handleDateChange={(date) => {
                  setNewDate(date)
                }}
                max={getLaterDate(visit?.service_date_from)}
                min={min}
              ></MobiScrollCalendar>
            </div>
          </div>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          onClick={async () => {
            if (
              moment.utc(dischargePatientEventDate).toISOString() ===
              moment.utc(newDate).toISOString()
            ) {
              toast.error('Date is same as original encounter Discharge Date')
              return
            }
            if (!isClicked) {
              setIsClicked(true)

              if (!isPatientEventCard) {
                let successful = visit?.dischargePatientEvent?._id
                  ? await overwritePatientEvent(newDate, visit?.dischargePatientEvent)
                  : await processPatientEventDate(visit, newDate, 'DISCHARGE')
                if (!successful) {
                  setIsClicked(false)
                  return
                }
              }

              await onChange(newDate)
              setIsClicked(false)
            }
          }}
        >
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
